import { Content, TableCell } from 'pdfmake/interfaces';
import * as types from '../types';

type SapNotificationsMap = { [key in types.ConditionParameter]: string[] } & {
  [key: string]: string[];
};

export const DividerLine = () => ({
  svg: `<svg width="520" height="1" ><rect width="510" height="1" x="5" fill="#E0E0E0"/></svg>`,
  colSpan: 5,
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
  alignment: 'center',
  height: 1,
  borderColor: ['#E0E0E0', '', '#E0E0E0', ''],
  border: [true, false, true, false],
});

const splitLines = (notificationNumbers: unknown[]) => {
  const lines = [];
  for (let i = 0; i <= notificationNumbers.length - 1; i += 2) {
    const tempLine = notificationNumbers.slice(i, i + 2);
    lines.push(
      tempLine.length === 2
        ? tempLine
        : [
            ...tempLine,
            {
              text: '',
              borderColor: ['#fff', '#fff', '#fff', '#fff'],
              border: [false, false, false, false],
            },
          ],
    );
  }

  return lines;
};

export const buildNotificationNumber = (sapNotificationsNumbers: string[]) =>
  sapNotificationsNumbers.map((number) => ({
    svg: `<svg width="40" height="14" ><rect width="40" height="14" fill="#F2F2F2" rx="3" ry="3" x="0" y="0"/>
    <text x="4" y="9" font-size="7" fill="#000">${number}</text></svg>`,
    margin: 0,
    border: [false, false, false, false],
  }));

export const buildSapNotificationsMap = (
  diagnostics: types.DeviationDetails[],
): SapNotificationsMap => {
  return diagnostics.reduce(
    (acc, diagnosticItem) => {
      return {
        ...acc,
        [diagnosticItem.condition_parameter]: [
          ...acc[diagnosticItem.condition_parameter],
          diagnosticItem.sap_notification,
        ],
      };
    },
    {
      'Auxiliary System': [],
      'Oil Analysis': [],
      'Dynamic Condition': [],
      'Process Condition': [],
    } as SapNotificationsMap,
  );
};

export const buildTemplateSapNotificationsPage = (content: TableCell[][]): Content => [
  {
    text: 'SAP Notifications',
    pageBreak: 'before',
    style: {
      fontSize: 10,
      bold: false,
    },
  },
  {
    layout: {
      paddingLeft: (i) => (i === 0 || i === 1 ? 5 : 10),
      paddingRight: (i) => (i === 0 || i === 4 ? 0 : 10),
      defaultBorder: false,
    },

    marginTop: 12,

    columnGap: 20,
    table: {
      headerRows: 1,
      widths: [105, 90, 'auto', 90, 95],
      body: [
        [
          {
            text: 'Equipment',
            border: [false, false, false, true],
            borderColor: ['', '', '', '#E0E0E0'],
            style: 'sapNotificationHeader',
          },
          {
            text: 'Auxiliary System',
            style: 'sapNotificationHeader',
            border: [false, false, false, true],
            borderColor: ['', '', '', '#E0E0E0'],
          },
          {
            text: 'Oil Analisys',
            style: 'sapNotificationHeader',
            border: [false, false, false, true],
            borderColor: ['', '', '', '#E0E0E0'],
          },
          {
            text: 'Dynamic Condition',
            style: 'sapNotificationHeader',
            border: [false, false, false, true],
            borderColor: ['', '', '', '#E0E0E0'],
          },
          {
            text: 'Process Condition',
            style: 'sapNotificationHeader',
            border: [false, false, false, true],
            borderColor: ['', '', '', '#E0E0E0'],
          },
        ],
        ...content,
        [
          {
            colSpan: 5,
            text: '',
            border: [false, true, false, false],
            borderColor: ['', '#E0E0E0', '', '#E0E0E0'],
          },
        ],
      ],
    },
  },
];
const buildNotificationTable = (sapNotificationsNumbers: string[], lastColumn?: boolean) => {
  if (sapNotificationsNumbers.length === 0) {
    return {
      text: '',
      borderColor: ['', '', '#E0E0E0', ''],
      border: [false, false, lastColumn, false],
    };
  }
  const formattedSapNotificationsNumbers = sapNotificationsNumbers.flatMap((sapNumber) =>
    sapNumber.split(' / '),
  );
  const notificationNumbers = buildNotificationNumber(formattedSapNotificationsNumbers);
  const lines = splitLines(notificationNumbers);

  return {
    layout: {
      hLineWidth: () => 0,
      vLineWidth: () => 0,
      paddingBottom: () => 2,
      paddingTop: () => 2,
      paddingLeft: () => 2,
      paddingRight: () => 2,
    },
    table: {
      body: lines,
      columnGap: 0,
    },
    margin: [0, 2, 0, 2],
    borderColor: ['', '', '#E0E0E0', ''],
    border: [false, false, lastColumn, false],
  };
};
export const buildEquipmentSapNotificationLine = (
  diagnostics: types.DeviationDetails[],
  equipmentName: string,
) => {
  const sapNotificationsMap = buildSapNotificationsMap(diagnostics);
  return [
    {
      text: equipmentName,
      fontSize: 7.5,
      color: '#445FFE',
      margin: [5, 6, 5, 6],
      borderColor: ['#E0E0E0', '', '', ''],
      border: [true, false, false, false],
    },
    buildNotificationTable(sapNotificationsMap['Auxiliary System']),
    buildNotificationTable(sapNotificationsMap['Oil Analysis']),
    buildNotificationTable(sapNotificationsMap['Dynamic Condition']),
    buildNotificationTable(sapNotificationsMap['Process Condition'], true),
  ];
};
